import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const reasons = [
    {
      id: 1,
      title: 'Diagnóstico Antes de Executar',
      description: 'Antes de qualquer serviço, avaliamos o problema para indicar a solução correta. Você entende o que será feito e por quê.',
      icon: '🔍'
    },
    {
      id: 2,
      title: 'Orçamento Claro e Justo',
      description: 'Sem taxas escondidas, sem serviço inventado. Transparência do início ao fim.',
      icon: '💰'
    },
    {
      id: 3,
      title: 'Execução Técnica Correta',
      description: 'Instalação e manutenção feitas da forma certa, evitando retrabalho e prejuízo futuro.',
      icon: '⚙️'
    },
    {
      id: 4,
      title: 'Atendimento Direto e Ágil',
      description: 'Você fala com quem resolve. Resposta rápida pelo WhatsApp.',
      icon: '⚡'
    },
    {
      id: 5,
      title: 'Foco em Evitar Gastos Desnecessários',
      description: 'Nosso objetivo é prolongar a vida útil dos seus equipamentos e não gerar serviço repetido.',
      icon: '💎'
    },
    {
      id: 6,
      title: 'Garantia de Satisfação',
      description: 'Trabalhamos com dedicação para superar suas expectativas e garantir sua total satisfação com nossos serviços.',
      icon: '✅'
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="why-choose-container">
        <div className="why-choose-header">
          <h2>Por Que Clientes Exigentes Escolhem a Brilha Piscina?</h2>
          <p className="why-choose-subtitle">Decisão Técnica. Sem risco. Sem surpresa.</p>
        </div>

        <div className="reasons-grid">
          {reasons.map((reason) => (
            <div key={reason.id} className="reason-card">
              <div className="reason-icon">{reason.icon}</div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="why-choose-cta">
          <a 
            href="https://wa.me/5521966527607?text=Olá! Tenho interesse nos serviços da Brilha Piscina. Gostaria de solicitar um orçamento."
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            Fale agora com um especialista
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
